// auth data service
import httpApi from '../httpApi';

class AuthService {
	status() {
		return httpApi.get('/auth/status');
	}
	
	session() {
		return httpApi.get('/auth/session');
	}
	
	counts() {
		return httpApi.get('/auth/counts');
	}
	
	identify(data) {
		return httpApi.post('/auth/identify', {
			email: data.email
		});
	}
	
	signup(data) {
		return httpApi.post('/auth/signup', {
			email: data.email,
			password: data.password
		});
	}
	
	verify(data) {
		return httpApi.post('/auth/verify', {
			verification: data.verification
		});
	}
	
	signin(data) {
		return httpApi.post('/auth/signin', {
			email: data.email,
			password: data.password,
			passcode: data.passcode || null,
			securityAnswer1: data.securityAnswer1 || null,
			securityAnswer2: data.securityAnswer2 || null,
		});
	}
	
	recover(data) {
		return httpApi.post('/auth/recover', {
			email: data.email
		});
	}

	signout() {
		return httpApi.get('/auth/signout');
	}
	
	notifications() {
		return httpApi.get('/auth/notifications');
	}
	
	dismiss(id) {
		return httpApi.post('/auth/dismiss', {
			id: id,
		});
	}
}

export default new AuthService();
